// extracted by mini-css-extract-plugin
export var emailInput = "NewsletterSignUp-module--email-input--cc370";
export var emailInputFieldError = "NewsletterSignUp-module--email-input-field-error--6d4aa";
export var errorText = "NewsletterSignUp-module--error-text--659a5";
export var form = "NewsletterSignUp-module--form--c60b3";
export var loadingRoot = "NewsletterSignUp-module--loading-root--4d797";
export var loadingText = "NewsletterSignUp-module--loading-text--077cf";
export var notice = "NewsletterSignUp-module--notice--3cb6a";
export var status = "NewsletterSignUp-module--status--5c97c";
export var successIcon = "NewsletterSignUp-module--success-icon--9d682";